import { ApiIncrementalityTest, ApiProject } from "@incendium/api";
import { useProjectSharedState } from "Hooks/useSharedState";
import { listIncrementalityTests } from "../services/incrementalityService";

const fetchIncrementalityTests = async (selectedProject: ApiProject) => {
  if (!selectedProject?.id) {
    return [];
  }
  return listIncrementalityTests(selectedProject.id);
};

export const useIncrementalityTests = () => {
  const { state, setState, refetch, loading, fetched } = useProjectSharedState(
    "incrementalityTests",
    [],
    fetchIncrementalityTests,
  );

  return {
    tests: state as ApiIncrementalityTest[],
    setTests: setState,
    refetchTests: refetch,
    loading,
    fetched,
  };
};
